import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getOrderListLogisticV2,
  getOrderListV2,
  GetOrderListV2ParamsType,
} from 'features/Order/services/order'
import { postStagingArea } from 'features/Order/services/stagingArea'
import { callErrorMsg } from 'helpers/errorMsg'

import type { PayloadStagingAreaThunkType } from 'features/Order/services/order'

export const postStagingAreaThunk = createAsyncThunk(
  'ongoingOrders/postStagingAreaThunk',
  async (payload: PayloadStagingAreaThunkType) => {
    const { orderId, ...restData } = payload.data
    try {
      const res = await postStagingArea(orderId, restData)
      if (res.data && payload.successCallback) {
        payload.successCallback()
      }
    } catch (err) {
      callErrorMsg(err)
    }
  },
)

export const getOrderListV2Thunk = createAsyncThunk(
  'ongoingOrders/getOrderListV2Thunk',
  async (payload: GetOrderListV2ParamsType) => {
    try {
      const { isFulfillment, ...rest } = payload
      const apiFulfillmentOrLogistic = isFulfillment ? getOrderListV2 : getOrderListLogisticV2
      const res = await apiFulfillmentOrLogistic(rest)
      return res.data
    } catch (err) {
      return callErrorMsg(err)
    }
  },
)
